<template>
  <div v-loading="loading" class="salesOrderPreview">
    <el-row style="text-align: left;margin-bottom: 5px">
      <el-button type="danger" style="margin-top: 5px">关闭</el-button>
      <el-button
          v-if="printAuth"
          type="success"
          style="margin-top: 5px"
          :loading="printSalesOrderLoading"
          @click="printSalesOrderVO">
        打印
      </el-button>
      <el-button
          v-if="cablePrintAuth"
          type="success"
          style="margin-top: 5px"
          :loading="printCableLoading"
          @click="printCable">
        线缆合同打印
      </el-button>
      <!--      <el-button type="primary" style="margin-top: 5px" @click="$refs.editMaterialNo.open(billId,billType)">发货单</el-button>-->
      <el-button type="primary" style="margin-top: 5px" @click="ardHandle">ARD参数</el-button>
    </el-row>
    <el-tabs type="border-card">
      <el-tab-pane label="主表信息">
        <table class="gridtable" style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">销售编号:</td>
            <td style="width: 23%">{{salesOrder.salesOrderNO}}</td>
            <td class="tableLabel">客户名称:</td>
            <td style="width: 23%">{{salesOrder.invoiceName}}</td>
            <td class="tableLabel">制单时间:</td>
            <td>{{salesOrder.createDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">项目类型：</td>
            <td colspan="1">{{salesOrder.subContract}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注:</td>
            <td colspan="5">{{salesOrder.note}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="费用清单">
        <div v-if="salesOrder.salesOrderMaterialVOes&&salesOrder.salesOrderMaterialVOes.length">
          <div v-if="salesOrder.priceVisible === true">
            <table class="gridtable" style="width: 100%; margin-top: 10px;">
              <tr>
                <td>配件：***</td>
                <td>电梯控制驱动一体机：***</td>
                <td>新时达电梯控制驱动一体机嵌入式软件 V1.0：***</td>
                <td colspan="2" align="center">
                  <el-button type="primary" :icon="isHidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="changeIsHidden">
                    {{isHidden ? "全部隐藏" : "全部展开"}}
                  </el-button>
                </td>
              </tr>
            </table>
            <el-table
                ref="multipleTable"
                :data="salesOrder.salesOrderMaterialVOes"
                style="width: 100%;margin-top: 20px;">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                      :data="props.row.salesOrderMaterialPropertyVOes"
                      style="width: 90%;margin: 0 auto">
                    <el-table-column label="特性名称" prop="propertyDisplayName"/>
                    <el-table-column label="特性值" prop="propertyDisplayValue"/>
                    <el-table-column label="审批意见" prop="approveNote"/>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="materialName" width="130" label="产品名称"/>
              <el-table-column prop="specification" label="规格型号"/>
              <el-table-column prop="quantity" width="60" label="数量"/>
              <el-table-column prop="note" width="300" label="备注"/>
            </el-table>
          </div>
          <div v-else>
            <table class="gridtable" style="width: 100%; margin-top: 10px;">
              <tr>
                <td>总费用：{{salesOrder.priceVisible?salesOrder.totalMoney:"***"}}</td>
                <td>电器控制器：***</td>
                <td>新时达电梯控制器嵌入式软件V1.0：***</td>
                <td>控制柜：***</td>
                <td>系统板：***</td>
              </tr>
              <tr>
                <td>配件：***</td>
                <td>电梯控制驱动一体机：***</td>
                <td>新时达电梯控制驱动一体机嵌入式软件 V1.0：***</td>
                <td colspan="2" align="center">
                  <el-button type="primary" :icon="isHidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="changeIsHidden">
                    {{isHidden ? "全部隐藏" : "全部展开"}}
                  </el-button>
                </td>
              </tr>
            </table>
            <el-table
                ref="multipleTable"
                :data="salesOrder.salesOrderMaterialVOes"
                style="width: 100%;margin-top: 20px;">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                      :data="props.row.salesOrderMaterialPropertyVOes"
                      style="width: 90%;margin: 0 auto">
                    <el-table-column label="特性名称" prop="propertyDisplayName"/>
                    <el-table-column label="特性值" prop="propertyDisplayValue"/>
                    <el-table-column label="审批意见" prop="approveNote"/>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="materialName" width="130" label="产品名称"/>
              <el-table-column prop="specification" label="规格型号"/>
              <el-table-column prop="quantity" width="60" label="数量"/>
              <el-table-column prop="note" width="300" label="备注"/>
            </el-table>
          </div>
        </div>
        <div v-if="salesOrder.salesOrderStandardMaterialVOes&&salesOrder.salesOrderStandardMaterialVOes.length">
          <el-table
              ref="multipleTable2"
              :data="salesOrder.salesOrderStandardMaterialVOes"
              style="width: 100%;margin-top: 20px;">
            <el-table-column align="center" prop="sapMaterialNo" label="物料编号"/>
            <el-table-column align="center" width="400" prop="sapMaterialDesc" label="物料描述"/>
            <el-table-column align="center" prop="quantity" label="数量"/>
            <el-table-column align="center" prop="unit" label="单位"/>
            <el-table-column align="center" prop="price" label="单价"/>
            <el-table-column align="center" prop="note" label="备注"/>
          </el-table>
        </div>
        <div v-if="salesOrder.salesOrderOtherItemVOes&&salesOrder.salesOrderOtherItemVOes.length">
          <el-table
              ref="multipleTable2"
              :data="salesOrder.salesOrderOtherItemVOes"
              style="width: 100%;margin-top: 20px;">
            <el-table-column align="center" prop="itemName" label="其他产品"/>
            <el-table-column align="center" prop="itemSpecification" label="规格型号"/>
            <el-table-column align="center" prop="quantity" label="数量"/>
            <el-table-column align="center" prop="note" label="备注"/>
          </el-table>
        </div>
        <el-table
            ref="multipleTable3"
            :data="salesOrder.salesOrderExpenseVOes"
            style="width: 100%;margin-top: 20px;">
          <el-table-column align="center" prop="expenseName" label="费用名称"/>
          <el-table-column align="center" prop="expense" label="费用">
            <template slot-scope="scope">
              <span v-if="salesOrder.priceVisible === true">{{scope.row.expense}}</span>
              <span v-else>***</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="note" label="备注"/>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="附件">
        <el-button type="primary">下载所有附件</el-button>
        <el-table :data="salesOrder.salesOrderAttachmentVOes" style="width: 100%;margin-top: 20px">
          <el-table-column prop="fileName" label="名称" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.fileName+"."+scope.row.filePath.split(".")[1]}}</span>
            </template>
          </el-table-column>
          <el-table-column label="下载" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
              <!--              <el-button type="danger" @click="attachmentDelete(scope.row)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <sales-material-edit ref="editMaterialNo"/>
    <handle-detail-by-supplier :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    <el-dialog v-el-drag-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="ARD参数">
      <table v-if="show" style="width: 100%" class="ardTable" cellspacing="0">
        <tr>
          <td colspan="4" class="tdName">ARD参数表</td>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[0].paramName}}</td>
          <td>
            <el-select v-model="ardArr[0].paramValue">
              <el-option label="国内项目" value="国内项目"/>
              <el-option label="国外项目" value="国外项目"/>
            </el-select>
          </td>
          <td class="tdName">{{ardArr[1].paramName}}</td>
          <td>
            <el-input v-model="ardArr[1].paramValue" placeholder="请输入"/>
          </td>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[2].paramName}}</td>
          <td>
            <el-input v-model="ardArr[2].paramValue" placeholder="请输入"/>
          </td>
          <td class="tdName">{{ardArr[3].paramName}}</td>
          <td>
            <el-input v-model="ardArr[3].paramValue" placeholder="请输入"/>
          </td>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[4].paramName}}</td>
          <td>
            <el-input v-model="ardArr[4].paramValue" placeholder="请输入"/>
          </td>
          <td/>
          <td/>
        </tr>
        <tr>
          <td class="tdName">{{ardArr[5].paramName}}</td>
          <td colspan="3">
            <el-input v-model="ardArr[5].paramValue" type="textarea" autosize placeholder="请输入"/>
          </td>
        </tr>
      </table>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <!--        <el-button type="primary" @click="submitHandle">保存</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>
<script>
  // import JSZip from "jszip";
  // import FileSaver from "file-saver";
  // import MaterialManagementSelect from "@/views/information/MaterialManagement/MaterialManagementSelect";
  import constant from "@/util/constant";
  import HandleDetailBySupplier from "@/views/workFlow/HandleDetailBySupplier";
  import SalesMaterialEdit from "@/views/salesManage/salesOrder/SalesMaterialEdit";
  // import SalesDeliveryDataEdit from "@/views/salesManage/salesOrder/SalesDeliveryDataEdit";
  // import SalesMaterialEdit from "@/views/salesManage/salesOrder/SalesMaterialEdit";

  export default {
    name: "SalesOrderPreviewBySupplierNew",
    components: {HandleDetailBySupplier,SalesMaterialEdit},
    data() {
      return {
        printAuth:this.$auth(657),
        cablePrintAuth:this.$auth(658),
        constant,
        loading: false,
        dialogVisible: false,
        exportExcelOfThsInfoLoading: false,
        printSalesOrderLoading: false,
        isHidden: false,
        printCableLoading: false,
        billId: "0",
        billType: "0",
        salesOrderNo: "",
        salesOrder: {
          material:"",
        },
        show: false,
        ardArr: [],
      };
    },
    created() {
      this.billType = this.$route.query.billType + "";
      this.billId = this.$route.query.billId + "";
      this.salesOrderNo = this.$route.query.orderNo;
      this.getData();
      console.log(this.$route.query);
    },
    methods: {
      async getData() {
        this.loading = true;
        let resp = await this.$http.get("basic", `sd/so/getSalesOrderByNo/${this.salesOrderNo}/0`);
        console.log(resp.data);
        this.loading = false;
        this.salesOrder = resp.data;
        this.billId = this.salesOrder.pkid + "";
        console.log(this.salesOrder);
        for (let item of this.salesOrder.salesOrderMaterialVOes) {
          this.$nextTick(() => {
            let list = this.getNewList(item.salesOrderMaterialPropertyVOes);
            item.salesOrderMaterialPropertyVOes = list;
          });
        }
      },
      getNewList(list) {
        let newList =[];
        for(let item of list) {
          if (item.propertyValue!=="" && item.visible) {
            console.log(item);
            newList.push(item);
          }
        }
        return newList;
      },
      ardHandle() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$http.get("basic", `sd/ExtParam/getByTechParamBillId/${this.billId}`).then((res) => {
            if (res.success) {
              this.show = true;
              if (res.data.length) {
                this.ardArr = res.data;
              } else {
                this.ardArr = [
                  {
                    masterId: this.billId,
                    paramName: "项目类型",
                    paramValue: "国内项目",
                  },
                  {
                    masterId: this.billId,
                    paramName: "变压器输入电压",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "抱闸电压",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "曳引机类型",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "抱闸电流",
                    paramValue: "",
                  },
                  {
                    masterId: this.billId,
                    paramName: "备注信息",
                    paramValue: this.salesOrder.note,
                  },
                ];
                console.log(this.ardArr);
              }
            }
          });
        });
      },
      submitHandle() {
        this.$http.post("basic", "sd/ExtParam/update", this.ardArr).then((res) => {
          console.log(res);
          if (res.success) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
          }
        });
      },
      changeIsHidden() {
        this.loading = true;
        this.$nextTick(() => {
          for (let item of this.salesOrder.salesOrderMaterialVOes) {
            this.$refs.multipleTable.toggleRowExpansion(item,this.isHidden);
          }
          this.loading = false;
        });
        this.isHidden = !this.isHidden;
      },

      //批量下载
      // handleBatchDownload() {
      //   const zip = new JSZip();
      //   const promises = [];
      //   const cache = {};
      //   this.salesOrder.salesOrderAttachmentVOes.forEach(item => {
      //     const promise = this.getFileData(item).then(data => {
      //       const arr_name = item.fileName.split("/");
      //       const file_name = arr_name[arr_name.length - 1]; // 获取文件名
      //       zip.file(file_name, data, { binary: true }); // 逐个添加文件
      //       cache[file_name] = data;
      //     });
      //     promises.push(promise);
      //   });
      //   Promise.all(promises).then(() => {
      //     zip.generateAsync({ type: "blob" }).then(content => {
      //       // 生成二进制流
      //       FileSaver.saveAs(content, "打包下载.zip"); // 利用file-saver保存文件
      //     });
      //   });
      // },
      // getFileData(item) {
      //   console.log(item);
      //   let url = window.config.fileServerUrl + item.filePath.replace("~", "");
      //   return new Promise((resolve, reject) => {
      //     this.$axios({
      //       method: "",
      //       url,
      //       responseType: "blob",
      //     })
      //       .then(data => {
      //         resolve(data.data);
      //       })
      //       .catch(error => {
      //         reject(error.toString());
      //       });
      //   });
      // },
      //下载
      downLoad(row) {
        let str = row.filePath.slice(0,1);
        if(str === "~") {
          let url = window.config.fileServerUrl + row.filePath.replace("~", "");
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }else{
          let data = {
            name:row.fileName,
            uuid:row.filePath,
          };
          this.$http.exportFile("basic","file/download",data).then(res => {
            console.log(res);
            let blob = new Blob([res.data],{type:"application"});
            let fileName = decodeURI(res.config.params.name);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downLoadLoading = false;
          }).catch(() => {
            this.downLoadLoading = false;
            this.$message.error("下载失败");
          });
        }
        
      },
      printSalesOrderVO() {
        let parms={
          techParamBillId:this.billId,
        };
        this.printSalesOrderLoading = true;
        this.$http.exportFile("basic", "sd/so/print",parms).then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" });
          // console.log(res);
          let a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // a.download = "可配置电子订单系统";
          a.target = "_blank";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
          // let pdfUrl = window.URL.createObjectURL(blob);
          // window.open(pdfUrl,"可配置电子订单系统");
        });
        this.printSalesOrderLoading = false;
      },
      // // 附件删除
      // attachmentDelete(row) {
      //   this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
      //     this.$http
      //       .delete("basic","/sd/so",row.pkid).then(() => {
      //         this.getList(-1);
      //         this.$message.success("删除成功");
      //       });
      //   });
      // },
      //线缆打印
      printCable() {
        let parms={
          techParamBillId:this.billId,
          supplierNo:"S011",
        };
        this.printCableLoading = true;
        this.$http.exportFile("basic", "sd/so/print",parms).then((res) => {
          let blob = new Blob([res.data], { type: "application/pdf" });
          // console.log(res);
          let a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // a.download = "可配置电子订单系统";
          a.target = "_blank";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
          this.printCableLoading = false;
          // let pdfUrl = window.URL.createObjectURL(blob);
          // window.open(pdfUrl,"可配置电子订单系统");
        })
          .catch(() => {
            this.printCableLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss">
  @media (max-width: 1280px) {
    .salesOrderPreview{
      width: 97%;
      overflow-x: scroll;
    }
  }
  .salesOrderPreview {
    .el-table th{
      background: #D1E6F5;
      height: 34px;
    }
    table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size:11px;
      color:#333333;
      border: 1px solid #EBEEF5;
      border-bottom: none;
      border-left: none;
    }
    table.gridtable tr td {
      padding: 8px;
      border-left: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
    }
    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #D1E6F5;
      border-left: 1px solid #EBEEF5;
    }
    .el-button{
      margin-left: 0!important;
      margin-right: 5px!important;
    }
  }
</style>
